import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, StateModel } from '@common/models';

export interface IQuestionStateModel extends IModel {
  questionStateId: number;
  questionId: number;
  stateId: number;
  state: StateModel;
}

export class QuestionStateModel
  extends Model
  implements ModelRecord<IQuestionStateModel>
{
  questionStateId: number;
  questionId: number;
  stateId: number;
  state: StateModel;

  constructor(params?: Partial<IQuestionStateModel>) {
    super(params);
    this.questionStateId = defaultTo(params?.questionStateId, 0);
    this.questionId = defaultTo(params?.questionId, 0);
    this.stateId = defaultTo(params?.stateId, 0);
    this.state = params?.state
      ? new StateModel(params?.state)
      : new StateModel();
  }
}
